function debounce(func, interval) {
  let lastCall = -1;
  // eslint-disable-next-line func-names
  return function () {
    clearTimeout(lastCall);
    // eslint-disable-next-line prefer-rest-params
    const args = arguments;
    const self = this;
    lastCall = setTimeout(() => {
      func.apply(self, args);
    }, interval);
  };
}

export default debounce;
